import { Tab, Tabs } from '@mui/material'
import { getTitle } from 'components/tabs/TabsTitle'
import { useTabsControl } from 'hooks/useTabsControl'
import React from 'react'
import { FamilyCaregiverTeamsPage } from '../FamilyCaregiverTeamsPage/FamilyCaregiverTeamsPage'
import { TeamsPage } from '../TeamsPage/TeamsPage'

enum TeamsTab {
  trainee = 'trainee',
  familyCaregiver = 'familyCaregiver',
}

export function TeamsMenuPage() {
  const { selectedTab, handleChangeSelectedTab } = useTabsControl<TeamsTab>(TeamsTab.trainee)

  const toolbarLeft = (
    <Tabs value={selectedTab} onChange={handleChangeSelectedTab} indicatorColor="primary">
      <Tab value={TeamsTab.trainee} label={getTitle('Trainee Teams')} />
      <Tab value={TeamsTab.familyCaregiver} label={getTitle('Family Caregiver Teams')} />
    </Tabs>
  )

  return (
    <>
      {selectedTab === TeamsTab.trainee && <TeamsPage toolbarLeft={toolbarLeft} />}
      {selectedTab === TeamsTab.familyCaregiver && (
        <FamilyCaregiverTeamsPage toolbarLeft={toolbarLeft} />
      )}
    </>
  )
}
